import request from '@/utils/http';

/**
 * 提交评价
 * @param data
 * @param data.id 订单id
 * @param data.evaluation_content 评价内容
 * @returns {AxiosPromise}
 */
const submitData = (data) => request({
  url: '/post-evaluation',
  method: 'post',
  data,
});

export default {
  submitData,
};
